export default __webpack_public_path__ + "images/9ee7889053cf26a02cd07894ec09f3eb-comedy.jpg";